<template>
  <v-expansion-panels class="accordion">
    <v-expansion-panel v-for="item in titleList" :key="item.no">
      <!-- 제목 -->
      <v-expansion-panel-header>
        {{ item.title }}
      </v-expansion-panel-header>

      <!-- 내용 -->
      <v-expansion-panel-content class="policy-list-wrap">
        <span v-if="item.no === 1" class="policy-content">
          본 약관은 주식회사
          <b>이수시스템</b>(이하 ‘회사’라 함)이 제공하는 클라우드 방식의
          <b>WORKUP서비스</b>
          (이하 “서비스”라 한다)를 이용함에 있어서 회사와 서비스이용자 (이하
          "회원"이라 한다)간에 서비스 이용의 방법 및 기타 필요한 사항을 규정함을
          목적으로 합니다.
        </span>

        <span v-else-if="item.no === 2" class="policy-content">
          본 약관에서 사용하는 용어의 정의는 아래와 같습니다.
          <ol class="policy-order-list">
            <li>
              서비스: 회원의 인사업무를 지원하는 클라우드 방식의 피플 플랫폼
              소프트웨어 인 워크업(영문명 <b>WORKUP</b>)를 이용할 수 있도록
              지원하는 서비스(이하 ‘서비스’)를 의미합니다.
            </li>
            <li>
              회원: 본 약관에 따라 회사와 서비스 이용계약을 체결하고 회사가
              제공하는 서 비스를 이용하는 개인 또는 기업을 의미합니다.
              <ul class="order-inner-list">
                <li>
                  관리자: 회원의 소속 직원으로 회원을 대표하여 임직원의 서비스
                  이용을 승인 및 개별 계정을 부여하고, 임직원의 서비스 이용에
                  대한 관리권한과 운영을 책임지는 자를 의미합니다.
                </li>
                <li>
                  임직원: 관리자에 의해 회원의 일원으로 승인 받아 관리자가
                  허용하는 범위 내에서 서비스를 이용하는 자를 의미합니다.
                </li>
              </ul>
            </li>
            <li>
              아이디(ID): 회원식별과 서비스 이용을 위하여 회원이 선정하고 회사가
              승인한 이메일 주소입니다.
            </li>
            <li>
              비밀번호: ID에 대하여 사용자임을 확인하고 회원 자신의 비밀 보호를
              위하여 회원이 선정하고 회사가 승인한 8자리 이상의 영문, 숫자, 특수
              기호의 조합입니다.
            </li>
            <li>
              데이터: 회원이 입력하여 회사의 서버 내에 저장되는 자료(상세 내용
              기재 필요) 및 그 자료들의 결합, 변형 또는 재 연산을 통하여
              생성되는 부가 자료 일체를 의미합니다.
            </li>
            <li>
              결제정보: 유료 서비스를 사용하는 회원의 서비스 이용요금 지급과
              관련하여 결제에 관련된 정보로, 결제 수단, 결제 내역 등을 말한다.
            </li>
          </ol>
          <br />
          ※ 이 약관에서 사용하는 용어의 정의는 위에서 정하는 것을 제외하고는
          관련법령에 서 정하는 바에 의하며, 관련 법령에서 정하지 않는 것은
          일반적인 상관습에 따릅니다.
        </span>

        <ol v-else-if="item.no === 3" class="policy-order-list">
          <li>
            회사는 이 약관을 회사의 서비스
            사이트(<b>https://hr.workup.plus/</b>)의 초기 서비스화면(전면)에
            게시합니다. 다만, 약관의 내용은 회원이 연결화면을 통하여 볼 수
            있도록 할 수 있습니다.
          </li>
          <li>
            회사는 제공하게 되는 새로운 서비스의 적용, 보안체계의 향상 및 유지,
            정부에 의한 시정명령의 이행 등 기타 회사의 업무상 약관을 변경하여야
            할 중요한 사유가 있다고 판단될 경우 약관을 변경할 수 있으며, 변경된
            약관은 제1항과 같은 방법으로 최소한 그 적용일 7일 전부터 회원에게
            공지합니다. 다만, 변경된 내용이 회원에게 불리하거나 중대한 사항의
            변경인 경우에는 그 적용일 30일 이전까지 제1항과 같은 방법으로
            공지하고, 회원에게 개별적으로 통지합니다.
          </li>
          <li>
            회사가 약관을 개정할 경우 개정약관 공지 후 개정약관의 적용에 대한
            회원의 동의 여부를 확인합니다. 회사는 제2항의 공지 또는 통지를 할
            경우 회원이 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않으면
            동의한 것으로 볼 수 있다는 내용도 함께 공지 또는 통지를 하며, 변경된
            약관의 시행일까지 회원이 회사에 이의를 제기하지 아니한 때에는 변경된
            약관을 승인한 것으로 간주합니다. 회원이 이의를 제기하는 경우 회사는
            회원과 협의를 거친 후 수용여부를 결정합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 4" class="policy-order-list">
          <li>
            본 약관에서 정하지 않은 사항과 본 약관의 해석에 관하여는
            「클라우드컴퓨팅 발전 및 이용자 보호에 관한 법률」, 「개인정보
            보호법」, 「신용정보의 이용 및 보 호에 관한 법률」, 「약관의 규제에
            관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」과
            관계 법령 또는 상관습에 따릅니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 5" class="policy-order-list">
          <li>
            본 서비스 이용 희망회원이 서비스 사이트에 접속하여 회원 약관의
            내용을 동의한 후 회사가 제시하는 양식과 절차에 따라 이용신청을 하고
            회사가 이러한 신청에 대하여 승낙함으로써 서비스에 관한 이용계약(이하
            ‘이용계약’)이 체결됩니다.
          </li>
          <li>
            회사는 회원의 서비스 이용 신청에 대하여 서비스 이용 승낙을 원칙으로
            합니다. 단, 다음 각 호의 어느 하나에 해당하는 이용신청에 대해서는
            승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다.
            <ul class="order-inner-list">
              <li>회원이 이용요금을 납부하지 않은 경우</li>
              <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
              <li>
                허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은
                경우
              </li>
              <li>만 14세 미만의 신청자인 경우</li>
              <li>
                회원이 이 계약에 의하여 이전에 이용회원의 자격을 상실한 사실이
                있는 경우, 단 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함
              </li>
              <li>
                회원이 서비스의 정상적인 제공을 저해하거나 다른 회원의 서비스
                이용에 지장을 줄 것으로 예상되는 경우
              </li>
              <li>
                기타 회사가 관련 법령 등을 기준으로 하여 명백하게 사회질서 및
                미풍양속에 반할 우려가 있음을 인정하는 경우
              </li>
              <li>
                제22조 ‘계약해지’에 의하여 회사로부터 계약해지를 당한 이후 1년이
                경과하지 않은 경우
              </li>
              <li>
                그 밖에 위 사항들에 준하는 사유로서 승낙하는 것이 상당히
                부적절하다고 판단되는 경우
              </li>
            </ul>
          </li>
          <li>
            제1항에 따른 신청에 있어 회사는 회원의 종류에 따라 전문기관을 통한
            실명 확인(법인사업자의 경우 실제 상호, 이하 같다) 및 본인인증을
            요청하거나 증빙자료를 요청할 수 있습니다.
          </li>
          <li>
            회원은 서비스 이용을 위해 허위 사실이 없는 진실된 정보를 제공하여야
            하며, 회사는 제공하는 서비스 상품에 따라 필요한 경우 회원에게 추가
            정보를 요청할 수 있습니다.
          </li>
          <li>
            유료 서비스를 이용하고자 하는 회원은 유료 서비스 요금제 및
            결제방법을 선 택하고 결제정보를 입력하거나 개별계약을 체결함으로써
            유료 서비스의 이용을 신청할 수 있습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 6" class="policy-order-list">
          <li>
            회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지
            않으며, 계속적이고 안정적인 서비스의 제공을 위하여 최선을 다하여
            노력합니다.
          </li>
          <li>
            회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보
            포함) 보호를 위해 보안시스템을 갖추어야 하며 개인정보 처리방침을
            공시하고 준수합니다.
          </li>
          <li>
            회사는 서비스 제공과 관련하여 알고 있는 회원의 개인정보를 회원의
            승낙없이 제3자에게 누설, 배포하지 않습니다.
          </li>
          <li>
            회사는 장애로 인하여 정상적인 서비스가 어려운 경우에 이를 신속하게
            수리 및 복구하고, 신속한 처리가 곤란한 경우에는 그 사유와 일정을
            회원에게 통지합니다.
          </li>
          <li>
            회사는 회원로부터 제기되는 의견이나 불만이 정당하다고 객관적으로
            인정될 경우에는 합리적인 기간 내에 신속하게 처리하여야 합니다. 다만,
            처리에 장기간 이 소요되는 경우는 회원에게 지체 사유를 안내하고
            처리과정 및 처리결과를 전 달합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 7" class="policy-order-list">
          <li>
            회원은 서비스 이용의 대가로 회사가 정한 서비스 이용요금을 지정된
            일자를 준수하여 납입하여야 합니다.
          </li>
          <li>
            회원은 다음 행위를 해서는 안됩니다.
            <ul class="order-inner-list">
              <li>
                서비스 이용 신청 또는 서비스 내용 변경 시 허위내용을 등록하는
                행위
              </li>
              <li>타인의 정보나 명의를 도용하거나 부정하게 사용하는 행위</li>
              <li>
                다른 회원의 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위
              </li>
              <li>회사가 게시한 정보를 변경하거나 제3자에게 제공하는 행위</li>
              <li>
                제3자의 코드, 파일, 프로그램을 포함하고 있는 자료를 무단으로
                게시하거나 메 일로 발송하는 행위 기타 회사 또는 제3자의
                지식재산권을 침해하는 행위
              </li>
              <li>
                회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위
              </li>
              <li>
                외설, 폭력적, 비방적인 내용 기타 풍기문란을 조장하거나
                공서양속에 반하는 내용 (어린이에게 유해하거나 제3자의 사생활을
                침해하는 내용을 포함합니다.) 또는 수신자의 동의 없이 발송하는
                광고성 내용 (정크메일, 스팸메일, 행운의 편지, 피라미드 조직에
                가입할 것을 권유하는 내용을 포함합니다.)의 메시지, 팩스, 음성,
                메일, 정보를 서비스에 공개 또는 게시하거나 제3자에게 전송하는
                행위
              </li>
              <li>
                회사의 동의 없이 본 약관의 목적 범위를 벗어나 영리를 목적으로
                서비스를 이 용하는 행위
              </li>
              <li>
                컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을
                방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 악성코드 등
                관련 법령에 의하여 전송 또는 게시가 금지되는 정보를 이용 또는
                전송하는 행위
              </li>
              <li>기타 불법적이거나 부당한 행위</li>
            </ul>
          </li>
          <li>
            회원은 회사의 명시적인 동의가 없는 한 서비스의 이용권한, 기타
            이용계약상 지위를 타인에게 양도, 증여, 담보로 제공하는 등 기타 이와
            유사한 행위를 할 수 없습니다.
          </li>
          <li>
            회원은 허용되지 않은 침입자로부터 안전하게 보호받을 수 있도록 시스템
            운 영과 관련한 정기적인 백신프로그램 등의 보안 업데이트를 하여야
            하며, 이를 소홀히 하여 발생한 보안 사고, 손해 등에 대하여 회사는
            책임을 지지 않습니다.
          </li>
          <li>
            회원은 서비스 이용과 관련하여 이메일 내용 등의 각종 데이터 등에 대해
            별 도로 상시 저장할 의무가 있으며, 이를 소홀히 하여 발생한 정보의
            유출, 누락 또는 자료의 손실에 대해 회사는 책임을 지지 않습니다.
          </li>
          <li>
            회원은 관계법, 본 약관의 규정, 이용안내 및 서비스와 관련하여 공지한
            주의 사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의
            업무에 방해되는 행위를 하여서는 안됩니다.
          </li>
          <li>
            회원은 스팸 또는 피싱 내용의 메일, 메시지, 팩스, 음성 (이하
            ‘불법스팸’) 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을
            준수하지 않아 발생하는 모든 민,형사상의 책임을 부담합니다. 회사는
            회원이 불법스팸을 전송한 사실을 확인한 경우, 한국 인터넷진흥원
            불법스팸대응센터에 관련 자료를 첨부하여 신고할 수 있습니다.
          </li>
          <li>
            회원에게 상속, 합병, 분할의 사유가 발생하여 회원이 아닌 제3자(이하
            ‘양수인’)가 회원이 회사와 맺은 이용계약에 따른 법적 지위를 승계하는
            경우 회원 및 양수인은 즉시 회사에 지위 승계를 입증할 수 있는 서류를
            첨부하여 회사가 지정한 방법과 절차에 따라 통지하여야 합니다. 이 경우
            양수인은 승계 이전에 약관 및 이용계약의 조건들을 완전히 이행할
            책임이 있습니다. 승계와 관련하여 문제가 발생하는 경우, 회원과
            양수인이 연대하여 책임을 집니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 8" class="policy-order-list">
          <li>
            회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에
            필요한 최소한의 회원정보를 수집합니다.
          </li>
          <li>
            회사는 회원정보의 수집시 관련 법규에 따라 개인정보 처리방침에 그
            수집범위 및 목적을 사전 고지합니다.
          </li>
          <li>
            회사는 서비스 화면에서 회사가 수집한 개인정보의 수집, 이용 또는
            제공에 대 한 동의를 철회할 수 있도록 필요한 조치를 취해야 합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 9" class="policy-order-list">
          <li>
            회사는 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한
            법률 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해
            노력합니다.
          </li>
          <li>
            회원의 개인정보 보호 및 이용에 대해서는 관련법 및 회사의 개인정보
            처리방침이 적용됩니다. 다만, 회사의 공식사이트 이외의 링크된
            사이트에서는 회사의 개인정보 처리방침이 적용되지 않습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 10" class="policy-order-list">
          <li>
            회원의 아이디와 비밀번호에 관한 관리 책임은 회원에게 있으며 이를
            제3자가 이용하도록 하여서는 안됩니다. 회원(관리자, 임직원 포함)의
            고의 또는 관리소홀 등의 과실로 인하여 아이디 또는 비밀번호가
            유출되어 발생한 제3자의 도용, 부 정사용 등에 대해서는 회사는 책임을
            지지 않습니다.
          </li>
          <li>
            회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을
            인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 하며,
            회사에 제3자 도용, 부정사용 사실을 통지하지 않거나 통지한 경우에도
            회사의 안내에 따르지 않아 발생한 불이익에 대해서 회사는 책임을 지지
            않습니다.
          </li>
          <li>
            회사는 회원의 아이디가 개인정보 유출 우려가 있거나 반사회적 또는
            미풍양속에 어긋나거나 회사 또는 운영자로 오인할 우려가 있는 경우
            해당 아이디의 활 용을 제한할 수 있습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 11" class="policy-order-list">
          <li>
            회원은 정보변경 페이지 화면을 통하여 회원 정보를 열람하고 수정할 수
            있습니다. 다만, 회원 내 관리자 계정은 회사의 별도 승낙이 없는 한
            수정이 불가능합니다.
          </li>
          <li>
            회원은 관리자 정보 등을 변경하려는 경우 유선연락 및 이메일을 통하여
            변경 사항을 고지하여야 하며, 변경사항 미수정 또는 변경사항 미통지로
            인하여 발생한 회원의 불이익에 대해서는 회사는 책임을 지지 않습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 12" class="policy-order-list">
          <li>
            회사는 본 약관에 별도 규정이 없는 한 회원이 등록한 정보로 회원에게
            통지할 수 있습니다. 회원이 이메일주소, 휴대전화번호 정보를 허위로
            제출 또는 등록하거나, 변경된 정보를 수정 또는 회사에 고지하지 않은
            경우 회사는 회원이 사 전에 제출 또는 등록한 정보로 발송한 때에
            회원에게 도달한 것으로 합니다.
          </li>
          <li>
            회사는 회원 전체에 대한 통지의 경우 7일 이상 회사의 홈페이지 또는
            공지사항 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.
            단, 회원의 권리 및 의무에 관련해 불리한 변경 사항을 통지하는
            경우에는 본 조항이 적용되지 않습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 13" class="policy-order-list">
          <li>
            회사는 회원에게 이용약관에 따른 서비스를 제공하여야 하며, 그 내용
            또는 이 행수준은 이용신청시 회원이 선택한 요금제가 제공하는 서비스
            내용에 따릅니다.
          </li>
          <li>
            회사는 서비스의 내용 또는 그 이행수준 변경 시 회원에게 불리하고 또한
            그 내용이 중요한 경우에는 회원의 동의를 얻어야 합니다.
          </li>
          <li>
            회원은 특정 임직원이 관리자로부터 승인받은 계정을 다른 임직원과
            공유하지 못하도록 이를 관리, 감독할 책임이 있습니다.
          </li>
          <li>
            회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며
            정기점검 시간은 회사가 사전에 통지한 바에 따릅니다. 이에 대하여
            관련법에 특별한 규정 이 없는 한 회원에게 별도의 보상을 하지
            않습니다.
          </li>
          <li>
            회사는 서비스와 외부 결제대행업체의 결제시스템을 연결해 회원이
            서비스 이 용요금을 결제할 수 있도록 결제시스템을 제공할 수 있습니다.
            단, 결제대행 업체의 시스템 장애 등 회사에게 책임 없는 사유로
            회원에게 손해가 발생한 경우 회 사는 면책됩니다.
          </li>
          <li>
            회사는 서비스의 전부 또는 일부를 변경할 수 있으며, 서비스의 내용,
            이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될
            서비스의 내용 및 제공일자 등을 그 변경 전에 제12조 회원에 대한
            통지의 방법으로 회원에게 통지합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 14" class="policy-order-list">
          <li>
            회사는 회원이 저작권법을 위반한 불법프로그램의 제공 및 운영방해,
            정보통신 망 이용촉진 및 정보보호 등에 관한 법률을 위반한 불법통신,
            해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을
            위반한 경우에는 즉시 영구이용 정지를 할 수 있습니다. 본 항에 따른
            서비스 이용정지 시 서비스 내의 혜택 및 권리 등도 모두 소멸되며
            회사는 이에 대해 별도로 보상하지 않습니다.
          </li>
          <li>
            회사는 다음 각 호의 어느 하나에 해당하는 경우에 서비스 이용을 제한
            혹은 정지할 수 있으며, 그 사유가 해소되면 지체 없이 서비스 제공을
            재개하여야 한다.
            <ul class="order-inner-list">
              <li>
                회원이 정당한 사유 없이 이용요금을 연체하여 체납금 및 가산금의
                이행을 최고받은 후 14일 이내에 이를 납입하지 않는 경우
              </li>
              <li>회원이 제3자에게 서비스를 임의로 제공하는 경우</li>
              <li>
                회원이 시스템 운영이나 네트워크 보안 등에 심각한 장애 혹은
                전자적 침해행위로 데이터의 손상, 서버정지 등을 초래하거나 그밖에
                이 계약의 규정에 위반하 거나 할 우려가 있는 행위를 한 경우
              </li>
              <li>
                기타 관련 법령에 위반하거나 회사의 업무를 방해하는 행위를 하는
                경우
              </li>
            </ul>
          </li>
          <li>
            회사는 제2항 1호에 따른 서비스를 정지하기 전 (14)일까지 그 사실을
            회원에 게 통지하고 이의신청의 기회를 주어야 합니다. 다만, 회원의
            책임 있는 사유로 통 지를 할 수 없는 때에는 그러하지 아니합니다.
          </li>
          <li>
            회사는 제2항 2, 3, 4호에 따른 서비스 이용 제한 혹은 정지는 사전 통지
            없이 진행할 수 있으며, 회사는 진행 후 그 사실을 회원에게 지체 없이
            통지하여야 합니 다.
          </li>
          <li>
            회사가 제2항 각 호에 따라 서비스를 정지한 경우에는 특별한 사유가
            없으면 회원은 그 기간 동안의 이용요금을 납부하여야 합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 15" class="policy-order-list">
          <li>
            회사가 제공하는 서비스 이용과 관련하여 회원이 납부하여야 할 서비스
            이용 요금 및 납부 방법은 홈페이지에 게재한 바에 따릅니다.
          </li>
          <li>
            서비스 이용요금은 다음 각 호의 요금을 포함하며, 구체적인 과금 기준에
            대해 서는 홈페이지에 고지합니다.
          </li>
          <li>
            회원이 서비스 이용 도중 서비스를 추가하는 경우에는 과금 시점의 ‘활성
            사용자 수’를 기준으로 과금됩니다. 단, 서비스 추가 인원이 회사 기준을
            초과할 시 회사가 확인하여 추가 청구를 회원에게 부담합니다.
          </li>
          <li>
            서비스 이용 도중 과금 기준 변경 시 이미 결제가 완료된 서비스
            이용분에 대 하여 비용의 증감이 있을 경우, 회사가 확인하여 추가 청구
            및 환불을 회원에게 부담합니다.
          </li>
          <li>
            회사는 판매 촉진, 회원 유치 등의 목적을 위해 회사의 정책에 따라 가격
            할인, 이용기간 연장 등 프로모션에 따른 혜택을 제공할 수 있습니다.
            회원의 서비스 신청 내용이 회사의 프로모션 제공 조건에 부합하지 않는
            경우 회사는 프로모션에 따른 혜택을 제공하지 않을 수 있으며, 회사는
            그에 대한 어떠한 책임도 부담하지 않습니다.
          </li>
          <li>
            서비스 이용요금에 대하여 회사와 회원 간에 별도 약정이 있는 경우,
            당해 약정내용이 본 약관에 우선하여 적용됩니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 16" class="policy-order-list">
          <li>
            회원은 다음 각 호의 방법 중 가능한 방법으로 서비스 이용요금을 결제할
            수 있습니다.
            <ul class="order-inner-list">
              <li>신용카드 결제</li>
              <li>전자세금계산서 발행</li>
            </ul>
          </li>
          <li>
            회원은 서비스 이용을 위한 서비스 이용요금 결제시 회사가 정하는 범위
            내에 서 결제수단과 결제방식을 선택할 수 있습니다. 단, 회사는
            직접적으로 전자결제 대행 결제방식을 제공하지 아니하므로,
            전자결제대행 방식과 관련하여 회사는 면책됩니다.
          </li>
          <li>
            신용카드 결제는 일정 기간마다 회원이 사전에 승인한 신용카드로 서비스
            이 용요금을 결제하는 방식을 말합니다.
          </li>
          <li>
            회원이 자동으로 이용계약을 갱신하고 싶을 경우, 철회 의사를 밝히지
            않는 한 회사가 정한 절차에 따라 회사가 자동으로 계약이 갱신됨을 통지
            후 이용계약이 갱신되고 결제가 이루어집니다.
          </li>
          <li>
            회원은 서비스 이용 요금을 결제함에 있어 다음에 기재한 사유가
            발생하지 않 도록 유의하여야 합니다.
            <ul class="order-inner-list">
              <li>회원 본인 외에 결제수단 사용을 금지합니다.</li>
              <li>
                회원은 결제수단의 비밀번호, 인증서 등의 유출로 인한 부정사용
                또는 위변조 사고가 발생하지 않도록 주의하여야 합니다. 특히
                회원은 신용카드의 미서명, 관 리 소홀, 무단 대여나 양도 또는
                담보제공으로 인한 부정사용, 불법 현금대출, 위 변조 사조 등이
                발생하지 않도록 주의하여야 합니다.
              </li>
            </ul>
          </li>
          <li>
            회사는 서비스 이용요금 결제가 정상적으로 이루어지지 않은 경우 회원의
            서 비스 이용을 제한할 수 있으며, 서비스 이용요금을 미납하는 등
            회원의 귀책 사 유로 회사가 서비스 이용을 제한한 경우 회원에게 발생한
            손해에 대해서 회사는 면책됩니다.
          </li>
          <li>
            회사는 회사의 사정에 따라 결제 방식, 결제 수단을 추가, 삭제, 변경할
            수 있으며, 사전에 그 사유와 적용일자를 공지합니다.
          </li>
          <li>
            회원은 전자세금계산서의 내용에 이의가 없으면 기재된 지급기일까지
            청구된 요금을 지급하여야 합니다.
          </li>
          <li>
            회원은 청구된 이용요금에 이의가 있으면 청구서가 도달한 날로부터
            3영업일 이내에 이의를 신청할 수 있고, 회사는 이의신청을 접수한
            날로부터 3영업일 이 내에 그 처리결과를 회원에게 통지하여야 합니다.
          </li>
          <li>
            회사의 고의 및 중대한 과실이 있거나 회사가 인정한 사유에 의한 경우를
            제 외하고 이용요금 미납으로 인해 발생하는 모든 문제에 대한 책임은
            회원에게 있 습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 17" class="policy-order-list">
          <li>
            회원은 청구된 서비스 이용요금 등에 대하여 이의가 없는 경우 이의
            신청을 할 수 있습니다. 단, 회사의 귀책사유로 과오납이 발생한 경우,
            회원은 전단의 기간에 관계없이 청구된 서비스 이용요금 등에 대하여
            이의 신청을 할 수 있습니다.
          </li>
          <li>
            회사는 제1항의 이의 신청 접수 후 2주 이내에 해당 이의신청을 타당성
            여부를 조사하여 그 결과를 회원에게 통지합니다.
          </li>
          <li>
            부득이한 사유로 인하여 제2항에서 정한 기간 내에 이의신청결과를
            통지할 수 없는 경우에는 그 사유와 재 지정된 처리 기한을 명시하여
            회원에게 통지합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 18" class="policy-order-list">
          <li>
            회사는 서비스 이용요금 등이 과납 또는 오납이 있을 때에는 그 과납
            또는 오납된 서비스 이용요금을 반환하고, 회사의 귀책사유로 과납 또는
            오납이 발생한 경우에는 회사 정책에 따라 계산하여 반환합니다.
          </li>
          <li>
            회원이 신용카드 결제 후 결제를 취소하는 경우 환급 금액, 환급 방법과
            환급일은 해당 신용카드 정책에 따르며, 회사는 결제취소에 필요한
            조치를 하는 것 외에 환급에 관하여 책임을 부담하지 않습니다. 단,
            회원의 결제 취소가 고의 또는 과실에 의한 경우에는 그러하지
            아니합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 19" class="policy-order-list">
          <li>
            회원은 이용계약을 해지하고자 할 때 본인이 직접 서비스를 통하여
            신청하거나 이메일, 전화 등의 방법을 통하여 회사에 신청하여야 합니다.
          </li>
          <li>
            회사는 전 1항의 규정에 의하여 해지신청이 접수되면 즉시 이용계약을
            해지합니다. 단, 별도의 채권, 채무 관계가 있을 경우에는 그러하지
            아니합니다.
          </li>
          <li>
            회사는 회원이 다음 각 호에 해당할 경우에는 회원의 동의 없이
            이용계약을 해지할 수 있으며 그 해지의 의사표시가 회원에게 도달한 때
            해지의 효력이 발생합니다. 다만 회사가 긴급하게 해지할 필요가 있다고
            인정하는 경우나 회원의 귀책사유로 인하여 통지할 수 없는 경우 에는
            지체없이 사후 통지로 대체할 수 있습니다.
            <ul class="order-inner-list">
              <li>
                회원이 제7조 ‘회원의 의무’를 포함한 본 약관을 위반하고 회사가 그
                시정을 요구한 때로부터 30일 이내에 위 반 내용을 해소하지 않은
                경우
              </li>
              <li>
                회사의 서비스 제공 목적 외의 용도로 서비스를 이용하거나
                제3자에게 임의로 서비스를 임대한 경우
              </li>
              <li>
                제14조 ‘서비스 이용의 제한 및 정지’ 규정에 의하여 이용정지를
                당한 이후 1년 이내에 이용정지 사유가 재발한 경우
              </li>
              <li>
                회사의 이용 요금 등의 납입청구에 대하여 회원이 이용요금을 체납할
                경우
              </li>
              <li>사업의 종료에 따라 서비스를 종료하는 경우</li>
            </ul>
          </li>
        </ol>

        <ol v-else-if="item.no === 20" class="policy-order-list">
          <li>
            회원은 워크업을 무단 복제하거나 고의 또는 과실로 워크업 및 서비스에
            관한 정보를 외부에 유출할 수 없습니다.
          </li>
          <li>
            회원은 이용계약 도중 또는 종료 후 라고 하더라도 워크업, 워크업과
            유사한 솔루션의 제작/판매행위를 할 수 없으며, 제3자를 통한 우회적
            제작/판매행위도 회원 본인의 행위로 간주합니다.
          </li>
          <li>
            회원은 전 1항 또는 2항을 위반할 경우, 민.형사상의 모든 법적 책임을
            부담합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 21" class="policy-order-list">
          <li>
            회원은 서비스 이용 중 데이터를 별도로 상시 백업, 저장하여야 하며,
            회사가 회원의 데이터를 백업하거나 회원에게 제공할 의무는 없습니다.
            회원이 전단의 의무를 소홀히 하여 발생한 데이터의 유출, 누락이나
            손실에 대해서는 회사는 책임을 부담하지 않습니다.
          </li>
          <li>
            서비스 이용기간 만료, 서비스 이용계약의 해제 또는 해지 등의 사유로
            회사가 서비스 제공을 종료한 경우 회사는 임직원의 정보를 비롯한 모든
            데이터를 즉시 파기합니다. 단, 다음 정보들은 관련 법령에 따라
            개인정보를 일정 기간 동안 보 존하며, 해당 개인정보 또는 개인정보
            파일을 다른 개인정보와 분리하여서 저장, 관리하고 보존기간 경과 후
            파기합니다.<br />
            ※ 개인정보 파기와 관련된 자세한 내용은 개인정보 처리방침에서
            확인하실 수 있습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 22" class="policy-order-list">
          <li>
            서비스 자체에 대한 지식재산권은 회사에게 귀속됩니다. 다만, 회원이
            서비스 이용 중 게시하거나 등록한 데이터의 지식재산권은 회원에게
            귀속됩니다.
          </li>
          <li>
            회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 게재된
            데이터를 상업적으로 이용할 수 없으며 이를 위반하여 발생하는 제반
            문제에 대한 책임 은 회원에게 있습니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 23" class="policy-order-list">
          <li>
            회사의 귀책사유로 회원이 서비스를 이용하지 못한 경우에는 (이하
            ‘장애’라 합니다) 다음 각 호의 기준에 따라 배상합니다.
            <ul class="order-inner-list">
              <li>
                회사는 회사의 귀책사유로 사전 고지 없이 발생한 장애 시간이
                연속하여 24시 간 이상인 경우 회원이 입은 손해를 배상합니다.
              </li>
              <li>
                회사는 회원이 서비스를 이용하지 못한 일수의 2배의 이용 기간을
                무료로 연장하여 제공합니다.
              </li>
              <li>
                본 조에서 장애라 함은 다음 각 호에 해당하는 경우 장애라고
                판단합니다. <br />
                1) 회사의 귀책 사유로 워크업 서비스를 사용하지 못한 경우 <br />
                ※ 단, 회사가 사전에 고지한 경우는 제외합니다.
              </li>
            </ul>
          </li>
          <li>
            회사가 고의 또는 과실로 회원에게 손해를 끼친 경우, 손해에 대하여
            배상할 책임이 있습니다.
          </li>
          <li>
            회원이 고의 또는 과실로 회사에 손해를 끼친 경우, 회원은 회사에
            대하여 그 손해에 대하여 배상할 책임이 있습니다.
          </li>
          <li>
            회사는 그 손해가 천재지변 등 불가항력이거나 회원의 고의 또는 과실로
            인하 여 발생된 때에는 손해배상을 하지 않습니다.
          </li>
          <li>
            손해 배상의 청구는 회사에 청구사유, 청구금액 및 산출근거를 기재하여
            이메 일, 전화 등으로 신청하여야 합니다.
          </li>
          <li>
            회사 및 타인에게 피해를 주어 피해자의 고발 또는 소송 제기로 인하여
            손해 배상이 청구된 회원은 회사 및 수사기관의 요청에 적극 협조하여야
            합니다.
          </li>
        </ol>

        <ol v-else-if="item.no === 24" class="policy-order-list">
          <li>
            회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여
            회원 또는 제3자에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.

            <ul class="order-inner-list">
              <li>천재 지변 또는 이에 준하는 불가항력의 상태가 있는 경우</li>
              <li>
                회원의 시스템 환경이나 통신사 또는 호스팅업체의 장애 등 회사의
                관리 범위 밖의 사정으로 인한 경우
              </li>
              <li>
                현재의 보안기술 수준으로는 방어가 곤란한 네트워크 해킹 등으로
                인한 경우
              </li>
              <li>
                서비스의 효율적인 제공을 위한 시스템 개선, 장비 증설 등 계획된
                서비스 중지 일정을 사전에 공지한 경우
              </li>
              <li>
                회원의 귀책사유로 메일 또는 데이터가 유출되거나 서비스 이용에
                장애가 있는 경우
              </li>
              <li>
                기타 버그, 바이러스, 트로이목마, 기타 유사한 것 등의 전송을
                원인으로 발생한 손해
              </li>
              <li>
                본 서비스를 통한 근로시간, 잔여연차 및 급여 등 모든 정산에 대한
                오차나 착오 로 발생된 손해
              </li>
              <li>회사의 고의 및 과실이 없는 경우</li>
            </ul>
          </li>
          <li>
            회사는 회원이 서비스를 통해 얻은 정보 또는 자료 등으로 인해 발생한
            손해 와 서비스를 이용하거나 이용할 것으로부터 발생하거나 기대하는
            손익 등 부가적, 영업적 손해에 대하여 책임을 면합니다. 단, 회원이
            서비스를 통해 얻은 정보 또는 자료를 신뢰함으로써 입게 된 손해에
            대하여 회사의 귀책사유가 있는 경우에는 그에 대한 배상책임을
            부담합니다.
          </li>
          <li>
            회사는 회원이 게시 또는 전송한 데이터의 내용에 대해서는 책임을
            면합니다.
          </li>
          <li>
            회사는 회원 상호 간 또는 회원과 제3자 상호 간에 서비스를 매개로 하여
            거래 등을 한 경우 이에 대해 개입할 의무가 없으며, 이로 인한 손해를
            배상할 책 임도 없습니다.
          </li>
          <li>
            회사는 무료로 제공하는 서비스 이용과 관련하여 관련법에 특별한 규정이
            없는 한 책임을 지지 않습니다.
          </li>
          <li>
            회사는 회원이 서비스 이용 종료 후 제21조에 따라 파기된 데이터와
            회원이 직접 삭제를 요청한 데이터 기타 서비스 이용 중인지 여부를
            불문하고 백업의무를 소홀히 하여 발생한 데이터의 손실에 대해서는
            책임을 지지 않습니다.
          </li>
          <li>
            회사는 서비스를 통하여 회원에게 제공된 정보, 자료, 사실의 신뢰도,
            정확성 등 그 내용에 대해서는 책임을 지지 않습니다.
          </li>
        </ol>

        <!-- 제25조 -->
        <ol v-else class="policy-order-list">
          <li>본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.</li>
          <li>
            서비스 이용과 관련하여 회사와 회원 간에 발생된 분쟁에 대해서는
            관계법령에 따른 법원을 합의관할로 합니다.
          </li>
        </ol>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  data: () => ({
    //
    titleList: [
      {
        no: 1,
        title: '제1조 목적',
      },
      {
        no: 2,
        title: '제2조 용어의 정의',
      },
      {
        no: 3,
        title: '제3조 약관의 효력 및 변경',
      },
      {
        no: 4,
        title: '제4조 약관외 준칙',
      },
      {
        no: 5,
        title: '제5조 이용신청 및 방법',
      },
      {
        no: 6,
        title: '제6조 회사의 의무',
      },
      {
        no: 7,
        title: '제7조 회원의 의무',
      },
      {
        no: 8,
        title: '제8조 회원정보 수집',
      },
      {
        no: 9,
        title: '제9조 개인정보보호 의무',
      },
      {
        no: 10,
        title: '제10조 회원의 아이디 및 비밀번호의 관리에 대한 의무',
      },
      {
        no: 11,
        title: '제11조 회원의 정보 변경',
      },
      {
        no: 12,
        title: '제12조 회원에 대한 통지',
      },
      {
        no: 13,
        title: '제13조 서비스 제공 및 변경',
      },
      {
        no: 14,
        title: '제14조 서비스 이용의 제한 및 정지',
      },
      {
        no: 15,
        title: '제15조 서비스 이용요금 등의 계산',
      },
      {
        no: 16,
        title: '제16조 서비스 이용요금의 청구와 지급',
      },
      {
        no: 17,
        title: '제17조 서비스 이용요금 등의 이의 신청',
      },
      {
        no: 18,
        title: '제18조 서비스 제공 및 변경',
      },
      {
        no: 19,
        title: '제19조 계약해지',
      },
      {
        no: 20,
        title: '제20조 서비스 동의 보호',
      },
      {
        no: 21,
        title: '제21조 데이터의 보존 및 파기',
      },
      {
        no: 22,
        title: '제22조 게시물의 저작권',
      },
      {
        no: 23,
        title: '제23조 손해배상의 범위 및 청구',
      },
      {
        no: 24,
        title: '제24조 면책',
      },
      {
        no: 25,
        title: '제25조 분쟁조정',
      },
    ],
  }),
};
</script>

<style scoped>
.policy-content {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.36px;
  color: #505961;
}
</style>
